import React, { useContext, useState } from "react";
import { toast } from "react-toastify";
import { modalActions } from "../../../../../../../../../../context/actions/modalActions";
import useStore from "../../../../../../../../../../context/useStore";
import dataService from "../../../../../../../../../../helpers/dataService";
import { ClientContext } from "../../../../../../ClientContext/ClientContext";
import MigrateClient from "./MigrateClient/MigrateClient";
import ResyncClientSummary from "./ResyncClientSummary/ResyncClientSummary";

const useCompanyOtherActions = (company, setCompany = () => {}) => {
  const [isRadierEntreprise, setIsRadierEntreprise] = useState(false);
  const [isRadieredEntreprise, setIsRadieredEntreprise] = useState(false);

  const [errors, setErrors] = useState({});
  const [state, dispatch] = useStore();
  const mActions = modalActions(state, dispatch);
  const { userCustomers, userCustomersActions } = useContext(ClientContext);

  const importModulr = () => {
    mActions.updateModal({
      isOpen: true,
      noClose: true,
      contentStyle: {
        height: "auto",
        maxHeight: "90%",
        maxWidth: 550,
        overflowY: "auto",
      },
      content: <ResyncClientSummary companyId={company.id} />,
    });
  };

  const radierEntreprise = () => {
    if (!window.confirm("Confirmez-vous la radiation de l'entreprise ?")) {
      return false;
    }
    setIsRadierEntreprise(true);
    dataService.patch(
      `clients/${company.id}/radier`,
      {},
      (data) => {
        toast.success("L'entreprise a été radiée.");
        setCompany({ ...company, isDelisted: true });
        setIsRadieredEntreprise(true);
      },
      setErrors,
      () => setIsRadierEntreprise(false)
    );
  };

  const openMigrationModal = () => {
    mActions.updateModal({
      isOpen: true,
      contentStyle: {},
      content: <MigrateClient companyId={company.id} />,
    });
  };

  return {
    errors,
    importModulr,
    openMigrationModal,
    isRadierEntreprise,
    isRadieredEntreprise,
    radierEntreprise,
  };
};

export default useCompanyOtherActions;
